import { visionMissionParagraphs, artemulkImages } from "../../data/artemulkContent";

/** Sadece /about sayfasında — anasayfada gösterilmez */
const VisionMission = () => {
  return (
    <section className="pt-8 pb-12 border-t border-gray-200 dark:border-gray-700">
      <div className="flex flex-wrap gap-12 lg:gap-16 items-center">
        <div className="flex-1 basis-[18rem] min-w-[280px]">
          <img
            src={artemulkImages.visionMission}
            alt="Vizyon ve Misyon"
            className="w-full rounded-[25px] object-cover border border-gray-200 dark:border-gray-700"
          />
        </div>
        <div className="flex-1 basis-[22rem] min-w-[280px]">
          <span className="sub-heading">Değerlerimiz</span>
          <h2 className="heading">Vizyonumuz & Misyonumuz</h2>
          <div className="mt-4 space-y-4">
            {visionMissionParagraphs.map((text) => (
              <p key={text.slice(0, 40)} className="leading-relaxed text-muted">
                {text}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionMission;
